import * as React from 'react';
import { Edit, SimpleForm, TextInput, required } from 'react-admin';

export const DailyRewardEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput disabled source="id" />
        <TextInput disabled source="day" />
        <TextInput disabled source="order" />
        <TextInput source="diamonds" validate={[required()]} />
      </SimpleForm>
    </Edit>
  );
};
